import { Component, ChangeDetectorRef, OnChanges, OnInit, SimpleChanges, Input } from "@angular/core";
import { WorkflowComponentsService } from "../../../workflow-components.service";
import { MultipackCommercialPlanningModel } from "../commercial-planning.model";
import { MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS, MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS_OPTIONS, MULTIPACK_COMMERCIAL_PLANNING_PRIORITES, MULTIPACK_COMMERCIAL_PLANNING_PRIORITES_OPTIONS } from "../commercial-planning.service";

@Component({
    selector: 'abw-multipack-commercial-planning-result',
    templateUrl: './commercial-planning-result.component.html',
    styleUrls: ['./commercial-planning-result.component.scss']
})
export class MultipackCommercialPlanningResultComponent implements OnInit, OnChanges {
    @Input() model: MultipackCommercialPlanningModel;
    @Input() value: any[];
    loading = false;
    operations: any = MULTIPACK_COMMERCIAL_PLANNING_OPERATIONS;
    priorites: any = MULTIPACK_COMMERCIAL_PLANNING_PRIORITES;

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef,
    ) {
    }

    ngOnInit() {
    }
    
    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.value?.currentValue) {
            console.log(this.value);
        }
    }
}